import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-toolkit-anagrafica-tab-anagrafica-legge",
  templateUrl: "./tab-anagrafica-legge.compontent.html",
})
export class ToolkitGestioneAnagraficaTabAnagraficaLeggeComponent
  implements OnInit
{
  @Input() formGroup: FormGroup;
  constructor() {}

  ngOnInit() {}
}
